module.exports = __webpack_public_path__ + "img/winBg_pop.7edd649b.png";